// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"225":"06458d18","838":"a673ff0b"}[chunkId] + ".js";
};